/**
 * @author Fernando Ruano
 * @file index.js
 * @description Button Filled Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './styles.module.css';

/**
 * Button Filled Component
 * @param { Object } props - React PropTypes
 * @property { Function } onActionClick - oClick Button function.
 * @property { String } textButton - Text button.
 * @property { String } classStyles - Button Style Class.
 */
const ButtonFilled = ({
  onActionClick,
  textButton,
  classStyles,
  iconComponent,
  htmlType,
  type,
  disabled
}) => {
  const { t: translate } = useTranslation();
  return (
    <Button
      disabled={disabled}
      htmlType={htmlType}
      onClick={onActionClick}
      className={[styles.filledButton, styles[type], classStyles]}
      type="primary"
      icon={iconComponent}>
      {translate(textButton)}
    </Button>
  );
};

/**
 * @name Buttonfilled.propTypes
 * @type { propTypes }
 * @property { Function } onActionClick - oClick function.
 * @property { String } textButton - Text button.
 * @property { String } classStyles - Button Style Class.
 */
ButtonFilled.propTypes = {
  onActionClick: PropTypes.func,
  textButton: PropTypes.string,
  classStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconComponent: PropTypes.object,
  htmlType: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};

/**
 * Default properties.
 */
ButtonFilled.defaultProps = {
  disabled: false
};

export default ButtonFilled;
